import { LocalizationKeys, type PartialTranslations } from '../../keys'

/**
 * Переводы регионов на английский язык
 */
export const enRegionTranslations: PartialTranslations = {
  [LocalizationKeys.REGION_UNSPECIFIED]: 'Not specified',
  
  // Europe
  [LocalizationKeys.REGION_RUSSIA]: 'Russia',
  [LocalizationKeys.REGION_UNITED_KINGDOM]: 'United Kingdom',
  [LocalizationKeys.REGION_GERMANY]: 'Germany',
  [LocalizationKeys.REGION_FRANCE]: 'France',
  [LocalizationKeys.REGION_ITALY]: 'Italy',
  [LocalizationKeys.REGION_SPAIN]: 'Spain',
  [LocalizationKeys.REGION_POLAND]: 'Poland',
  [LocalizationKeys.REGION_UKRAINE]: 'Ukraine',
  [LocalizationKeys.REGION_NETHERLANDS]: 'Netherlands',
  [LocalizationKeys.REGION_BELGIUM]: 'Belgium',
  [LocalizationKeys.REGION_SWEDEN]: 'Sweden',
  [LocalizationKeys.REGION_SWITZERLAND]: 'Switzerland',
  [LocalizationKeys.REGION_AUSTRIA]: 'Austria',
  [LocalizationKeys.REGION_DENMARK]: 'Denmark',
  [LocalizationKeys.REGION_NORWAY]: 'Norway',
  [LocalizationKeys.REGION_FINLAND]: 'Finland',
  [LocalizationKeys.REGION_PORTUGAL]: 'Portugal',
  [LocalizationKeys.REGION_GREECE]: 'Greece',
  [LocalizationKeys.REGION_IRELAND]: 'Ireland',
  [LocalizationKeys.REGION_CZECH_REPUBLIC]: 'Czech Republic',
  [LocalizationKeys.REGION_HUNGARY]: 'Hungary',
  [LocalizationKeys.REGION_ROMANIA]: 'Romania',
  [LocalizationKeys.REGION_BULGARIA]: 'Bulgaria',
  [LocalizationKeys.REGION_SLOVAKIA]: 'Slovakia',
  [LocalizationKeys.REGION_CROATIA]: 'Croatia',
  [LocalizationKeys.REGION_SERBIA]: 'Serbia',
  [LocalizationKeys.REGION_BOSNIA_AND_HERZEGOVINA]: 'Bosnia and Herzegovina',
  [LocalizationKeys.REGION_ALBANIA]: 'Albania',
  [LocalizationKeys.REGION_LITHUANIA]: 'Lithuania',
  [LocalizationKeys.REGION_LATVIA]: 'Latvia',
  [LocalizationKeys.REGION_ESTONIA]: 'Estonia',
  [LocalizationKeys.REGION_SLOVENIA]: 'Slovenia',
  [LocalizationKeys.REGION_NORTH_MACEDONIA]: 'North Macedonia',
  [LocalizationKeys.REGION_MONTENEGRO]: 'Montenegro',
  [LocalizationKeys.REGION_KOSOVO]: 'Kosovo',
  [LocalizationKeys.REGION_MOLDOVA]: 'Moldova',
  [LocalizationKeys.REGION_BELARUS]: 'Belarus',
  [LocalizationKeys.REGION_LUXEMBOURG]: 'Luxembourg',
  [LocalizationKeys.REGION_ICELAND]: 'Iceland',
  [LocalizationKeys.REGION_ANDORRA]: 'Andorra',
  [LocalizationKeys.REGION_MONACO]: 'Monaco',
  [LocalizationKeys.REGION_LIECHTENSTEIN]: 'Liechtenstein',
  [LocalizationKeys.REGION_SAN_MARINO]: 'San Marino',
  [LocalizationKeys.REGION_MALTA]: 'Malta',
  [LocalizationKeys.REGION_CYPRUS]: 'Cyprus',
  [LocalizationKeys.REGION_TURKEY]: 'Turkey',
  [LocalizationKeys.REGION_ISRAEL]: 'Israel',

  // Americas
  [LocalizationKeys.REGION_UNITED_STATES]: 'United States',
  [LocalizationKeys.REGION_CANADA]: 'Canada',
  [LocalizationKeys.REGION_MEXICO]: 'Mexico',
  [LocalizationKeys.REGION_BRAZIL]: 'Brazil',
  [LocalizationKeys.REGION_ARGENTINA]: 'Argentina',
  [LocalizationKeys.REGION_CHILE]: 'Chile',
  [LocalizationKeys.REGION_COLOMBIA]: 'Colombia',
  [LocalizationKeys.REGION_PERU]: 'Peru',
  [LocalizationKeys.REGION_VENEZUELA]: 'Venezuela',
  [LocalizationKeys.REGION_ECUADOR]: 'Ecuador',
  [LocalizationKeys.REGION_BOLIVIA]: 'Bolivia',
  [LocalizationKeys.REGION_PARAGUAY]: 'Paraguay',
  [LocalizationKeys.REGION_URUGUAY]: 'Uruguay',
  [LocalizationKeys.REGION_COSTA_RICA]: 'Costa Rica',
  [LocalizationKeys.REGION_PANAMA]: 'Panama',
  [LocalizationKeys.REGION_GUATEMALA]: 'Guatemala',
  [LocalizationKeys.REGION_EL_SALVADOR]: 'El Salvador',
  [LocalizationKeys.REGION_HONDURAS]: 'Honduras',
  [LocalizationKeys.REGION_NICARAGUA]: 'Nicaragua',
  [LocalizationKeys.REGION_DOMINICAN_REPUBLIC]: 'Dominican Republic',
  [LocalizationKeys.REGION_CUBA]: 'Cuba',
  [LocalizationKeys.REGION_HAITI]: 'Haiti',
  [LocalizationKeys.REGION_JAMAICA]: 'Jamaica',
  [LocalizationKeys.REGION_TRINIDAD_AND_TOBAGO]: 'Trinidad and Tobago',
  [LocalizationKeys.REGION_BAHAMAS]: 'Bahamas',
  [LocalizationKeys.REGION_BARBADOS]: 'Barbados',
  [LocalizationKeys.REGION_SAINT_LUCIA]: 'Saint Lucia',
  [LocalizationKeys.REGION_ANTIGUA_AND_BARBUDA]: 'Antigua and Barbuda',
  [LocalizationKeys.REGION_DOMINICA]: 'Dominica',
  [LocalizationKeys.REGION_GRENADA]: 'Grenada',
  [LocalizationKeys.REGION_SAINT_KITTS_AND_NEVIS]: 'Saint Kitts and Nevis',
  [LocalizationKeys.REGION_SAINT_VINCENT_AND_THE_GRENADINES]: 'Saint Vincent and the Grenadines',
  [LocalizationKeys.REGION_BELIZE]: 'Belize',
  [LocalizationKeys.REGION_GUYANA]: 'Guyana',
  [LocalizationKeys.REGION_SURINAME]: 'Suriname',

  // Asia
  [LocalizationKeys.REGION_CHINA]: 'China',
  [LocalizationKeys.REGION_JAPAN]: 'Japan',
  [LocalizationKeys.REGION_SOUTH_KOREA]: 'South Korea',
  [LocalizationKeys.REGION_INDIA]: 'India',
  [LocalizationKeys.REGION_INDONESIA]: 'Indonesia',
  [LocalizationKeys.REGION_PHILIPPINES]: 'Philippines',
  [LocalizationKeys.REGION_VIETNAM]: 'Vietnam',
  [LocalizationKeys.REGION_THAILAND]: 'Thailand',
  [LocalizationKeys.REGION_MALAYSIA]: 'Malaysia',
  [LocalizationKeys.REGION_SINGAPORE]: 'Singapore',
  [LocalizationKeys.REGION_PAKISTAN]: 'Pakistan',
  [LocalizationKeys.REGION_BANGLADESH]: 'Bangladesh',
  [LocalizationKeys.REGION_SRI_LANKA]: 'Sri Lanka',
  [LocalizationKeys.REGION_NEPAL]: 'Nepal',
  [LocalizationKeys.REGION_MYANMAR]: 'Myanmar',
  [LocalizationKeys.REGION_CAMBODIA]: 'Cambodia',
  [LocalizationKeys.REGION_LAOS]: 'Laos',
  [LocalizationKeys.REGION_BRUNEI]: 'Brunei',
  [LocalizationKeys.REGION_MONGOLIA]: 'Mongolia',
  [LocalizationKeys.REGION_NORTH_KOREA]: 'North Korea',
  [LocalizationKeys.REGION_TAIWAN]: 'Taiwan',
  [LocalizationKeys.REGION_HONG_KONG]: 'Hong Kong',
  [LocalizationKeys.REGION_MACAU]: 'Macau',
  [LocalizationKeys.REGION_KAZAKHSTAN]: 'Kazakhstan',
  [LocalizationKeys.REGION_UZBEKISTAN]: 'Uzbekistan',
  [LocalizationKeys.REGION_TURKMENISTAN]: 'Turkmenistan',
  [LocalizationKeys.REGION_KYRGYZSTAN]: 'Kyrgyzstan',
  [LocalizationKeys.REGION_TAJIKISTAN]: 'Tajikistan',
  [LocalizationKeys.REGION_AFGHANISTAN]: 'Afghanistan',
  [LocalizationKeys.REGION_MALDIVES]: 'Maldives',
  [LocalizationKeys.REGION_BHUTAN]: 'Bhutan',
  [LocalizationKeys.REGION_TIMOR_LESTE]: 'Timor-Leste',

  // Middle East
  [LocalizationKeys.REGION_UNITED_ARAB_EMIRATES]: 'United Arab Emirates',
  [LocalizationKeys.REGION_SAUDI_ARABIA]: 'Saudi Arabia',
  [LocalizationKeys.REGION_IRAN]: 'Iran',
  [LocalizationKeys.REGION_IRAQ]: 'Iraq',
  [LocalizationKeys.REGION_SYRIA]: 'Syria',
  [LocalizationKeys.REGION_LEBANON]: 'Lebanon',
  [LocalizationKeys.REGION_JORDAN]: 'Jordan',
  [LocalizationKeys.REGION_YEMEN]: 'Yemen',
  [LocalizationKeys.REGION_OMAN]: 'Oman',
  [LocalizationKeys.REGION_QATAR]: 'Qatar',
  [LocalizationKeys.REGION_KUWAIT]: 'Kuwait',
  [LocalizationKeys.REGION_BAHRAIN]: 'Bahrain',
  [LocalizationKeys.REGION_PALESTINE]: 'Palestine',

  // Africa
  [LocalizationKeys.REGION_EGYPT]: 'Egypt',
  [LocalizationKeys.REGION_NIGERIA]: 'Nigeria',
  [LocalizationKeys.REGION_SOUTH_AFRICA]: 'South Africa',
  [LocalizationKeys.REGION_KENYA]: 'Kenya',
  [LocalizationKeys.REGION_GHANA]: 'Ghana',
  [LocalizationKeys.REGION_ALGERIA]: 'Algeria',
  [LocalizationKeys.REGION_MOROCCO]: 'Morocco',
  [LocalizationKeys.REGION_ETHIOPIA]: 'Ethiopia',
  [LocalizationKeys.REGION_TANZANIA]: 'Tanzania',
  [LocalizationKeys.REGION_UGANDA]: 'Uganda',
  [LocalizationKeys.REGION_SUDAN]: 'Sudan',
  [LocalizationKeys.REGION_TUNISIA]: 'Tunisia',
  [LocalizationKeys.REGION_LIBYA]: 'Libya',
  [LocalizationKeys.REGION_ANGOLA]: 'Angola',
  [LocalizationKeys.REGION_CAMEROON]: 'Cameroon',
  [LocalizationKeys.REGION_IVORY_COAST]: 'Ivory Coast',
  [LocalizationKeys.REGION_MADAGASCAR]: 'Madagascar',
  [LocalizationKeys.REGION_SENEGAL]: 'Senegal',
  [LocalizationKeys.REGION_ZIMBABWE]: 'Zimbabwe',
  [LocalizationKeys.REGION_MOZAMBIQUE]: 'Mozambique',
  [LocalizationKeys.REGION_ZAMBIA]: 'Zambia',
  [LocalizationKeys.REGION_MALAWI]: 'Malawi',
  [LocalizationKeys.REGION_BURKINA_FASO]: 'Burkina Faso',
  [LocalizationKeys.REGION_MALI]: 'Mali',
  [LocalizationKeys.REGION_NIGER]: 'Niger',
  [LocalizationKeys.REGION_CHAD]: 'Chad',
  [LocalizationKeys.REGION_SOMALIA]: 'Somalia',
  [LocalizationKeys.REGION_ERITREA]: 'Eritrea',
  [LocalizationKeys.REGION_RWANDA]: 'Rwanda',
  [LocalizationKeys.REGION_BURUNDI]: 'Burundi',
  [LocalizationKeys.REGION_BENIN]: 'Benin',
  [LocalizationKeys.REGION_TOGO]: 'Togo',
  [LocalizationKeys.REGION_GUINEA]: 'Guinea',
  [LocalizationKeys.REGION_SIERRA_LEONE]: 'Sierra Leone',
  [LocalizationKeys.REGION_LIBERIA]: 'Liberia',
  [LocalizationKeys.REGION_CENTRAL_AFRICAN_REPUBLIC]: 'Central African Republic',
  [LocalizationKeys.REGION_CONGO_DEMOCRATIC_REPUBLIC]: 'Democratic Republic of the Congo',
  [LocalizationKeys.REGION_CONGO]: 'Republic of the Congo',
  [LocalizationKeys.REGION_GABON]: 'Gabon',
  [LocalizationKeys.REGION_EQUATORIAL_GUINEA]: 'Equatorial Guinea',
  [LocalizationKeys.REGION_SAO_TOME_AND_PRINCIPE]: 'São Tomé and Príncipe',
  [LocalizationKeys.REGION_MAURITIUS]: 'Mauritius',
  [LocalizationKeys.REGION_SEYCHELLES]: 'Seychelles',
  [LocalizationKeys.REGION_COMOROS]: 'Comoros',
  [LocalizationKeys.REGION_CAPE_VERDE]: 'Cape Verde',
  [LocalizationKeys.REGION_ESWATINI]: 'Eswatini',
  [LocalizationKeys.REGION_LESOTHO]: 'Lesotho',
  [LocalizationKeys.REGION_BOTSWANA]: 'Botswana',
  [LocalizationKeys.REGION_NAMIBIA]: 'Namibia',
  [LocalizationKeys.REGION_SOUTH_SUDAN]: 'South Sudan',
  [LocalizationKeys.REGION_DJIBOUTI]: 'Djibouti',
  [LocalizationKeys.REGION_MAURITANIA]: 'Mauritania',
  [LocalizationKeys.REGION_GAMBIA]: 'Gambia',
  [LocalizationKeys.REGION_GUINEA_BISSAU]: 'Guinea-Bissau',

  // Oceania
  [LocalizationKeys.REGION_AUSTRALIA]: 'Australia',
  [LocalizationKeys.REGION_NEW_ZEALAND]: 'New Zealand',
  [LocalizationKeys.REGION_PAPUA_NEW_GUINEA]: 'Papua New Guinea',
  [LocalizationKeys.REGION_FIJI]: 'Fiji',
  [LocalizationKeys.REGION_SOLOMON_ISLANDS]: 'Solomon Islands',
  [LocalizationKeys.REGION_VANUATU]: 'Vanuatu',
  [LocalizationKeys.REGION_SAMOA]: 'Samoa',
  [LocalizationKeys.REGION_TONGA]: 'Tonga',
  [LocalizationKeys.REGION_KIRIBATI]: 'Kiribati',
  [LocalizationKeys.REGION_MICRONESIA]: 'Micronesia',
  [LocalizationKeys.REGION_PALAU]: 'Palau',
  [LocalizationKeys.REGION_MARSHALL_ISLANDS]: 'Marshall Islands',
  [LocalizationKeys.REGION_NAURU]: 'Nauru',
  [LocalizationKeys.REGION_TUVALU]: 'Tuvalu',
} as const satisfies PartialTranslations
